<template>
    <transition name="fade">
        <div class="more-popup-wrapper" :style="commonStyle" v-show="isShow">
            <slot>
                <div class="cover" @click="hide"></div>
                <div class="content-wrapper">
                    <div class="close" @click="hide">x</div>
                    <div class="hint">{{ hintText }}</div>
                    <a :href="buttonLink" class="button">{{ buttonText }}</a>
                </div>
            </slot>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        buttonStyle: {
            type: Object,
            default: null
        },
        visible: {
            type: Boolean,
            default: false
        },
        hintText: {
            type: String,
            default: '点击下方按钮阅读全文'
        },
        buttonText: {
            type: String,
            default: '阅读全文'
        },
        buttonLink: {
            type: String,
            default: null
        }
    },
    computed: {
        commonStyle() {
            if (this.buttonStyle) {
                const styleObj = {}
                for (let [key, value] of Object.entries(this.buttonStyle)) {
                    styleObj[`--${key}`] = value
                }
                return styleObj
            }
            return {}
        },
        isShow: {
            get() {
                return this.visible
            },
            set(v) {
                this.$emit('update:visible', v)
            }
        }
    },
    methods: {
        hide() {
            this.isShow = false
        }
    }
}
</script>

<style scoped lang="less">
@import '../assets/var';

.more-popup-wrapper {
    z-index: 999;
    --blue: @blue;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    .cover {
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
    }
    .close {
        right: 5px;
        top: 5px;
    }
    .content-wrapper {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        background: #fff;
        padding: 20px 30px;
        border-radius: 5px;
        line-height: 2;
    }
    .hint {
        margin-bottom: 12px;
    }
    .button {
        text-decoration: none;
        color: var(--blue);
        border: 1px solid var(--blue);
        padding: 3px 6px;
        border-radius: 3px;
    }
}
</style>
